import React, { useEffect, useRef, useState } from 'react';
import {  useNavigate } from 'react-router-dom';
import {  add_bug_to_issue, add_typo_to_issue, add_user_permission_to_issue, change_ticket_status, get_issue_full, load_annotations, load_issue_bugs, load_issue_observers, load_issue_typos, loadIssueType_helpdesk, remove_issue_bug, remove_issue_observer, remove_issue_typos, save_annotation, save_new_issue, set_CAS_to_issue, update_issue } from '../../../utils/services';
import {
    list_root_materials_inventory_consolidated,
    insert_root_materials_inventory_movement,
    load_issue_inventory_movements,
    delete_root_material_inventory_movement,
} from '../../../utils/cas_services';
import Type_link from './modal/Type_link';
import Modal_proyectos from '../../menus/Modal';
import { Alert, Badge, Button, Col, InputGroup,  Form, Row, Table } from 'react-bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css'; // ¡Agrega esta línea!
import Select from 'react-select';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Estilo "snow" para el editor
import DOMPurify from 'dompurify';
import Team_link from '../crm/modals/Team_link';
import StatusBar from './StatusBar';
import CAS_select from './modal/CAS_select';
import { set } from 'date-fns';
import Bug_link from './modal/Bug_link';

const formatInventoryDate = (dt) => {
    if (!dt) return '—';
    const d = new Date(dt);
    if (Number.isNaN(d.getTime())) return String(dt);
    return d.toLocaleString();
};


const Ticket_panel = ({permission,   token,  usr_id, issue_updating_id,  onCloseAnnotation}) => {
    const navigate = useNavigate();
    const [estado, setEstado] = useState(0);
    
    const [canal, setcanal] = useState("");
    const [persona_contacto, setpersona_contacto] = useState("");
    const [email_contacto, setEmail_contacto] = useState("");
    const [telefono_contacto, setTelefono_contacto] = useState("");
     const [direccion_contacto, setDireccion_conctacto] = useState("");
    const [change2Save, setchange2Save] = useState(false);


    const [creator, setCreator] = useState("");
    const [creationDate, setCreationDate] = useState("");
    const [typos, setTypos] = useState([ ]);
    const [Bugs, setBugs] = useState([ ]);
    const [observers, setObservers] = useState([]);
    const [attachedFile, setattachedFile] = useState(null);
    const [attachedFile2, setattachedFile2] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
        
    const [logEntry, setLogEntry] = useState('');
    const [logEntry2, setLogEntry2] = useState('');
    const [log, setLog] = useState([]);
    const [content_title, setmodal_content_title] = useState("");
    const [newStatus, setNewStatus] = useState(null);
    const [newStatuslabel, setnewStatuslabel] = useState(null);

     const [changingCasStatus, setChangingCasStatus] = useState(null);
    

    const [isModalOpen, setModalOpen] = useState(false);
    let [modal_content, setmodal_content] = useState(""); 

    const [dropdownOptions, setDropdownOptions] = useState([]); 
    const [CAS_name, setCASname] = useState(null); 
    const [CAS_id, setCASid] = useState(0);
    const [CASstatus, setCASstatus] = useState(0); 
    const [casRemitMode, setCasRemitMode] = useState('with_flow');

    const [issueInventoryRows, setIssueInventoryRows] = useState([]);
    const [issueInventoryLoading, setIssueInventoryLoading] = useState(false);
    const [issueInventoryError, setIssueInventoryError] = useState('');
    const [issueInventoryModalOpen, setIssueInventoryModalOpen] = useState(false);
    const [issueInventorySaving, setIssueInventorySaving] = useState(false);
    const [issueInventoryProductOptions, setIssueInventoryProductOptions] = useState([]);
    const [issueInventoryProduct, setIssueInventoryProduct] = useState(null);
    const [issueInventoryQty, setIssueInventoryQty] = useState('');
    const [issueInventoryRef, setIssueInventoryRef] = useState('');
    const [issueInventoryDescription, setIssueInventoryDescription] = useState('');
    const [issueInventoryProductTouched, setIssueInventoryProductTouched] = useState(false);
    const [issueInventoryQtyTouched, setIssueInventoryQtyTouched] = useState(false);
    const [showNoPartsConfirmation, setShowNoPartsConfirmation] = useState(false);
    const [confirmedNoPartsForApproval, setConfirmedNoPartsForApproval] = useState(false);
   
      useEffect(() => {
    
         fetch_issueType();  
         fetchloadBugsLink(issue_updating_id);
         fetchloadTypology(issue_updating_id); 
         fetchload_annotation(issue_updating_id);
         fetchloadObservers();
     
       }, [token]); 

       async function fetch_issueType() {
           const issueTypelist = await loadIssueType_helpdesk(token);
           if (issueTypelist==="INVALID"){
             navigate("/");
           }else{
     
            
             const issueTypeNames = issueTypelist.map((element, index) => {
                 return { id: element.id, 
                    name: element.name_issue_type, 
                    category: element.category,
                    index: index };
               });
             
             issueTypeNames.unshift("Seleccione uno...");
             setDropdownOptions(issueTypeNames);
             
          }
         }
            const modules = {
            toolbar: [
                ['bold', 'italic', 'underline'], 
                [{ 'color': [
                    '#000000', '#e60000', '#ff9900', '#008a00', '#0066cc', 'gray'
                ]
                }], 
            ],
            };

            // Necesitarás una función para manejar el archivo seleccionado
        const handleFileChange = (e) => {
            const file = e.target.files[0];
            if (file) {
                setattachedFile(file);
            }
        };

        const handleFileChange2 = (e) => {
            const file = e.target.files[0];
            if (file) {
                setattachedFile2(file);
            }
        };


       useEffect(()=>{
            if (issue_updating_id!=null){
             fetch_full_issue(issue_updating_id);
             loadIssueInventory();
            }
       }
        ,[issue_updating_id]


       );

        async function fetch_full_issue(issue_id) {
           const issuefull = await get_issue_full(token, issue_id);
           if (issuefull==="INVALID"){
             navigate("/");
           }else{
                
                setpersona_contacto(issuefull['issue_info'][0].persona_contacto);
                setEmail_contacto(issuefull['issue_info'][0].email_contacto);
                setTelefono_contacto(issuefull['issue_info'][0].telefono_contacto);
                setDireccion_conctacto(issuefull['issue_info'][0].direccion_contacto);
                setcanal(issuefull['issue_info'][0].canal);
                setEstado (parseInt(issuefull['issue_info'][0].status));
                setCreator (issuefull['issue_info'][0].creator);
                setCreationDate(issuefull['issue_info'][0].date);
                setCASname(issuefull['issue_info'][0].CAS_name);
                setCASid(parseInt(issuefull['issue_info'][0].CAS_id || 0));
                setCASstatus(issuefull['issue_info'][0].CAS_status);


             
          }
        }

        async function updateAnnotation() {
            const issuefull = await update_issue(token, issue_updating_id, persona_contacto, email_contacto, telefono_contacto, canal, direccion_contacto);
           if (issuefull==="INVALID"){
             navigate("/");
           }else{
                setchange2Save(false);
                sendLog("Actualización de información general del ticket",null,1);
               fetch_full_issue(issue_updating_id);
          }
        }

        const issueInventoryQtyNum = parseInt(String(issueInventoryQty).trim(), 10);
        const issueInventoryProductInvalid = issueInventoryProductTouched && !issueInventoryProduct;
        const issueInventoryQtyInvalid = issueInventoryQtyTouched && (!Number.isFinite(issueInventoryQtyNum) || issueInventoryQtyNum < 1);

        const resetIssueInventoryForm = () => {
            setIssueInventoryProduct(null);
            setIssueInventoryQty('');
            setIssueInventoryRef('');
            setIssueInventoryDescription('');
            setIssueInventoryProductTouched(false);
            setIssueInventoryQtyTouched(false);
            setIssueInventoryError('');
            setIssueInventorySaving(false);
        };

        const closeIssueInventoryModal = () => {
            setIssueInventoryModalOpen(false);
            resetIssueInventoryForm();
        };

        const loadIssueInventory = async () => {
            if (!issue_updating_id) return;
            setIssueInventoryLoading(true);
            setIssueInventoryError('');
            const rows = await load_issue_inventory_movements(token, issue_updating_id);
            setIssueInventoryLoading(false);
            if (rows === "INVALID"){
                navigate("/");
                return;
            }
            if (Array.isArray(rows)) {
                setIssueInventoryRows(rows);
            } else {
                setIssueInventoryRows([]);
                setIssueInventoryError('No se pudo cargar el inventario del ticket.');
            }
        };

        const loadIssueInventoryProducts = async () => {
            if (!CAS_id) {
                setIssueInventoryProductOptions([]);
                return;
            }
            const rows = await list_root_materials_inventory_consolidated(token, CAS_id);
            if (rows === "INVALID"){
                navigate("/");
                return;
            }
            if (Array.isArray(rows)) {
                setIssueInventoryProductOptions(
                    rows.map((r) => ({
                        value: String(r.root_material_id),
                        label: `${r.root_material_name == null ? '' : String(r.root_material_name)} (${Number(r.qty_balance ?? 0)})`,
                        availableQty: Number(r.qty_balance ?? 0),
                    }))
                );
            } else {
                setIssueInventoryProductOptions([]);
            }
        };

        const openIssueInventoryModal = async () => {
            if (!issue_updating_id) return;
            if (!CAS_id) {
                alert('Selecciona un CAS para este ticket antes de registrar movimientos de inventario.');
                return;
            }
            await loadIssueInventoryProducts();
            setIssueInventoryModalOpen(true);
        };

        const saveIssueInventoryOutMovement = async () => {
            setIssueInventoryProductTouched(true);
            setIssueInventoryQtyTouched(true);
            if (!issueInventoryProduct) return;
            if (!Number.isFinite(issueInventoryQtyNum) || issueInventoryQtyNum < 1) return;
            if (!CAS_id) {
                setIssueInventoryError('El ticket no tiene CAS asociado.');
                return;
            }

            setIssueInventorySaving(true);
            setIssueInventoryError('');
            const res = await insert_root_materials_inventory_movement(
                token,
                CAS_id,
                issueInventoryProduct.value,
                issueInventoryQtyNum,
                issueInventoryRef.trim(),
                issueInventoryDescription.trim(),
                issue_updating_id,
                1
            );
            setIssueInventorySaving(false);
            if (res === "INVALID"){
                navigate("/");
                return;
            }
            if (res && res.ok) {
                closeIssueInventoryModal();
                loadIssueInventory();
            } else {
                if (res && res.debug) {
                    console.error('saveIssueInventoryOutMovement:', res.debug);
                }
                setIssueInventoryError((res && res.error) ? res.error : 'No se pudo insertar el movimiento.');
            }
        };

        const removeIssueInventoryMovement = async (movementId) => {
            if (!window.confirm('¿Eliminar este movimiento de inventario?')) return;
            const res = await delete_root_material_inventory_movement(token, movementId);
            if (res === "INVALID"){
                navigate("/");
                return;
            }
            if (res && res.ok) {
                loadIssueInventory();
            } else {
                if (res && res.debug) {
                    console.error('removeIssueInventoryMovement:', res.debug);
                }
                alert((res && res.error) ? res.error : 'No se pudo eliminar el movimiento.');
            }
        };

        const hasIssueOutInventoryMovements = () => {
            if (!Array.isArray(issueInventoryRows) || issueInventoryRows.length === 0) return false;
            return issueInventoryRows.some((row) => Number(row?.type) === 1 || Number(row?.qty) < 0);
        };

        const isRepairApprovedTransition = () =>
            Boolean(changingCasStatus) && Number(newStatus) === 4;

        const buildStatusChangeLog = (baseLogText, appendNoPartsText = false) => {
            const normalized = String(baseLogText ?? '').trim();
            const withoutPartsText = 'NO REQUIRIO PARTES DE INVENTARIO';
            if (!appendNoPartsText) return normalized;
            if (!normalized) return withoutPartsText;
            return `${normalized}\n\n${withoutPartsText}`;
        };


    async function changeStatus(new_status, log_save_text, attachedfile_tosend, forceNoPartsConfirmation = false) {
        if (
            isRepairApprovedTransition() &&
            !forceNoPartsConfirmation &&
            !hasIssueOutInventoryMovements()
        ) {
            setShowNoPartsConfirmation(true);
            return;
        }

        const finalLogText = buildStatusChangeLog(log_save_text, forceNoPartsConfirmation || confirmedNoPartsForApproval);

        if (changingCasStatus ){
            if (!attachedfile_tosend){
                alert("Para cambiar el estado de reparación es necesario adjuntar un archivo con la evidencia del cambio de estado");
                return;
            }
             sendLog( newStatuslabel + "\n\n"  + finalLogText, attachedfile_tosend) ;
            const issuefull = await change_ticket_status(token, issue_updating_id, new_status, "CAS_status");
            if (issuefull==="INVALID"){
                navigate("/");
            }else{
                setLogEntry2("");
                setattachedFile2(null);
                setShowNoPartsConfirmation(false);
                setConfirmedNoPartsForApproval(false);
                setModalOpen(false);
                fetch_full_issue(issue_updating_id);
            }
        }else{
      
            sendLog("Cambio de estado general de ticket: " + newStatuslabel + "\n\n"  + log_save_text, attachedfile_tosend) ;
            const issuefull = await change_ticket_status(token, issue_updating_id, new_status, "status");
            if (issuefull==="INVALID"){
                navigate("/");
            }else{
                setLogEntry2("");
                setattachedFile2(null);
                setShowNoPartsConfirmation(false);
                setConfirmedNoPartsForApproval(false);
                setModalOpen(false);
                fetch_full_issue(issue_updating_id);
            }
        }

    }


    
        
    
    
    
   

    const setNewTypoLink =(trello_id, title)=>{
        addTypology(trello_id);
        setModalOpen(false);
    }

      const setBug =(trello_id, title, urlTrello)=>{
        addBug(trello_id, title, urlTrello);
        setModalOpen(false);
    }


    
    const setCAS =(channelCASid, title, startFlow = true)=>{
        addChannelCAS(channelCASid, title, startFlow);
       
    }

    
    async function addChannelCAS(channelID, title, startFlow = true) {
    
            const addUserPerm = await set_CAS_to_issue(token, issue_updating_id, channelID, startFlow ? 1 : 0);
            if (addUserPerm==="INVALID"){
              navigate("/");
            }else{
                
                const remitLog = startFlow
                    ? "Remitido a CAS: " + title
                    : "Remitido a CAS (sin flujo): " + title;
                sendLog(remitLog, null,1);
                fetch_full_issue(issue_updating_id);
                setModalOpen(false);
            }
                
    }

    async function addTypology(typo_id) {
    
            const addUserPerm = await add_typo_to_issue(token,issue_updating_id, typo_id);
            if (addUserPerm==="INVALID"){
              navigate("/");
            }else{
                fetchloadTypology(issue_updating_id);
            }
                
    }

    
    async function addBug(bug_id, title, urlTrello) {
            const addUserPerm = await add_bug_to_issue(token,issue_updating_id, bug_id, title, urlTrello);
            if (addUserPerm==="INVALID"){
              navigate("/");
            }else{
                fetchloadBugsLink(issue_updating_id);
            }
                
    }

       async function fetchloadBugsLink(issue_id) {
           
            const typoList = await load_issue_bugs(token,issue_id);
                if (typoList==="INVALID"){
                    navigate("/");
                }else{
                   const tempIssues = typoList["bugs"].map((celement, index) => {
   
                    return {
                        link_id: celement.id,
                        title: celement.title,
                        bug_id: celement.bug_id,
                        trello_url: celement.trello_url,
                        index:index
                    };
                  });
               
                   setBugs( tempIssues);
        
                    
                }
                  
            }
     async function fetchloadTypology(issue_id) {
           
            const typoList = await load_issue_typos(token,issue_id);
                if (typoList==="INVALID"){
                    navigate("/");
                }else{
                   const tempTypos = typoList["typos"].map((celement, index) => {
   
                    return {
                        link_id: celement.id,
                        name_issue_type: celement.name_issue_type,
                        type_id: celement.type_id,
                        index:index
                    };
                  });
               
                   setTypos( tempTypos);
        
                    
                }
                  
            }

    async function onRemoveTypo(link_id){
        const typoList = await remove_issue_typos(token, link_id);
                if (typoList==="INVALID"){
                    navigate("/");
                }else{
                     fetchloadTypology(issue_updating_id);
                }
    }


    async function onRemoveBug(link_id){
        const typoList = await remove_issue_bug(token, link_id);
                if (typoList==="INVALID"){
                    navigate("/");
                }else{
                   fetchloadBugsLink(issue_updating_id);
                }
    }

        async function onRemoveObserver(link_id){
        const typoList = await remove_issue_observer(token, link_id);
                if (typoList==="INVALID"){
                    navigate("/");
                }else{
                    fetchloadObservers(issue_updating_id);
                }
    }

const getColorForId = (id) => {
  const hue = (id * 41) % 360;
   return `hsl(${hue}, 60%, 50%)`; 
};


  const sendLog = (log_save_text, attachedfile_tosend, type=0) => {
    if (!log_save_text.trim()) return;
    fetchsave_annotation(log_save_text, attachedfile_tosend, type);

  };

  async function fetchsave_annotation(logMessage, attachedFileFinal, type){
    setIsSubmitting(true); 
        const typoList = await save_annotation(token, issue_updating_id, logMessage,usr_id, attachedFileFinal, type);
                if (typoList==="INVALID"){
                    navigate("/");
                }else{
                    setLog("");
                    setLogEntry("");
                    setattachedFile(null);
                    fetchload_annotation(issue_updating_id);
                    setIsSubmitting(false); 
                }
    }

    

   async function fetchload_annotation(issue_id){
        const annotationsList = await load_annotations(token, issue_id);
                if (annotationsList==="INVALID"){
                    navigate("/");
                }else{
                    if (annotationsList){
                    const templog= annotationsList.map((celement, index) => {
                    return {
                        id: celement.id,
                        issue_date: celement.date_comment,
                        description: celement.comment,
                        type_name: celement.type_name,
                        type: celement.type,
                        url_attached:celement.attached_file!==""?"https://team.tomi.la/storage/helpdesk/" + issue_updating_id + "/" + celement.attached_file:"",
                        user_by: celement.usr_name,
                        index:index
                    };
                    });

                    setLog( templog);
                    }
                }
    }

    const handelStatusChange = (status, statusLabel)=>{
        if (parseInt(permission) != 1 ){
            alert("Only administrator could change the status");
            return;
        }

        setmodal_content("Change_status");
        setmodal_content_title("Cambiar estado a: " + statusLabel);
        setnewStatuslabel(statusLabel);
        setChangingCasStatus(false);
        setNewStatus(status);
        setModalOpen(true);
    }

    

    const setNewMember =(id)=>{
        setModalOpen(false);
        addUserPermission(id);
    }

    const changeCASStatus =(step, statusLabel)=>{
        if (parseInt(permission) != 1 ){
            if (step === 4 || step === 7){
                  alert("Solo el administrador de la mesa de ayuda puede aprobar este paso.");
                  return;
            }

          
        }

        setNewStatus(step);
        setnewStatuslabel(statusLabel);
        setChangingCasStatus(true);
        setmodal_content("Change_status");
        setmodal_content_title("Cambiar estado de reparación a: " + statusLabel);
        setShowNoPartsConfirmation(false);
        setConfirmedNoPartsForApproval(false);

        setModalOpen(true);
    }


    async function addUserPermission(usr_id_permission) {
    
            const addUserPerm = await add_user_permission_to_issue(token,issue_updating_id, usr_id_permission);
            if (addUserPerm==="INVALID"){
              navigate("/");
            }else{
                fetchloadObservers(issue_updating_id);
           }
    }


    
    async function fetchloadObservers() {
    
            const addObservers= await load_issue_observers(token,issue_updating_id);
            if (addObservers==="INVALID"){
              navigate("/");
            }else{
                  const tempObservers = addObservers["observers"].map((celement, index) => {
                    return {
                        link_id: celement.id,
                        name: celement.usr_name,
                        team_usr_id: celement.team_usr_id,
                        index:index
                    };
            });

            setObservers(tempObservers);

           }
    }
    

    return (
        <>

        <Modal_proyectos isOpen={isModalOpen} onClose={() => setModalOpen(false)} 
                contentClassName={modal_content === 'Change_status' ? 'modal-content2--status-change' : undefined}
                title={
                        modal_content === 'Type_link' ? 'Agregar Tipologías' :
                        modal_content === 'Known_case' ? 'Asociar a caso conocido' :
                        modal_content === 'CAS_link' ? 'Seleccione un CAS' :
                        modal_content === 'Bugs_link' ? 'Seleccione un Bug' :
                        modal_content === 'Change_status' ? content_title :
                        ''
                    }
            >  
                 {modal_content === 'Team_link'  &&  <Team_link  onSet={(id) => setNewMember(id)}></Team_link>}  
                 {modal_content === 'Type_link'  &&  <Type_link typesOptions={dropdownOptions} onSet={(id, name) => setNewTypoLink(id, name)}></Type_link>}
                 {modal_content === 'CAS_link'  && (
                    <>
                        <div className="d-flex gap-2 mb-3">
                            <Button
                                variant={casRemitMode === 'with_flow' ? 'primary' : 'outline-primary'}
                                onClick={() => setCasRemitMode('with_flow')}
                            >
                                Remitir con flujo
                            </Button>
                            <Button
                                variant={casRemitMode === 'without_flow' ? 'secondary' : 'outline-secondary'}
                                onClick={() => setCasRemitMode('without_flow')}
                            >
                                Remitir sin flujo
                            </Button>
                        </div>
                        <CAS_select token={token} onSet={(id, name) => setCAS(id, name, casRemitMode === 'with_flow')} />
                    </>
                 )}  
                 {modal_content === 'Bugs_link'  &&  <Bug_link  token={token} onSet={(id, name, urlTrello) => setBug(id, name, urlTrello)}></Bug_link>}  
               
                 {modal_content === 'Change_status'  &&  
                 
                                <div style={{ position: 'relative' }}>

                                {/* 2. Capa de carga que se muestra condicionalmente */}
                                {isSubmitting && (
                                    <div className="loading-overlay">
                                        {/* Puedes usar un ícono de Bootstrap, FontAwesome o un spinner */}
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Enviando...</span>
                                        </div>
                                    </div>
                                )}

                                {/* Tu contenido actual del formulario */}
                                <div className={`mb-3 status-change-editor ${isSubmitting ? 'content-blocked' : ''}`}>
                                <ReactQuill
                                theme="snow"
                                value={logEntry2}
                                onChange={setLogEntry2}
                                modules={modules}
                                placeholder="El usuario verá la anotación que agregues aquí..."
                                />
                            </div>

                            {showNoPartsConfirmation ? (
                                <Alert variant="warning" className="mb-3">
                                    <Alert.Heading className="h6 mb-2">Validación de inventario CAS</Alert.Heading>
                                    <p className="mb-2">
                                        Este ticket no tiene movimientos OUT/negativos de inventario cargados.
                                    </p>
                                    <p className="mb-3">
                                        Si confirma, el caso quedará guardado y la anotación agregará:
                                        <strong> NO REQUIRIO PARTES DE INVENTARIO</strong>.
                                    </p>
                                    <div className="d-flex justify-content-end gap-2">
                                        <Button
                                            variant="outline-secondary"
                                            onClick={() => {
                                                setShowNoPartsConfirmation(false);
                                                setConfirmedNoPartsForApproval(false);
                                            }}
                                        >
                                            Cancelar
                                        </Button>
                                        <Button
                                            variant="warning"
                                            className="fw-bold px-4"
                                            onClick={async () => {
                                                setConfirmedNoPartsForApproval(true);
                                                setShowNoPartsConfirmation(false);
                                                await changeStatus(newStatus, logEntry2, attachedFile2, true);
                                            }}
                                        >
                                            Este Caso NO requirió partes para su reparación
                                        </Button>
                                    </div>
                                </Alert>
                            ) : null}

                            {/* Ponemos los botones de acción juntos debajo del editor */}
                                        <div className="d-flex justify-content-end align-items-center gap-2 mb-2">
                                            
                                            {/* Botón para adjuntar archivo (ahora separado) */}
                                            <Button 
                                                    variant="outline-secondary" 
                                                    onClick={() => document.getElementById('file-upload-input').click()} 
                                                    title="Adjuntar evidencia"
                                                >
                                                    <i className="bi bi-paperclip"></i>
                                                </Button>
                                                
                                                {/* Input de archivo, permanece oculto */}
                                                <Form.Control
                                                    id="file-upload-input"
                                                    type="file"
                                                    className="d-none"
                                                    onChange={(e) => handleFileChange2(e)}
                                                />
                                                
                                                {/* Esta sección solo aparece si hay un archivo adjunto */}
                                                {attachedFile2 && (
                                                    <div className="d-flex align-items-center mt-2 p-2 border rounded">
                                                    <span className="me-auto">
                                                        <strong>Adjunto:</strong> {attachedFile2.name}
                                                    </span>
                                                    {/* Botón para eliminar el archivo adjunto */}
                                                    <Button 
                                                        variant="outline-danger" 
                                                        size="sm" 
                                                        onClick={() => setattachedFile2(null)} 
                                                        title="Quitar archivo"
                                                    >
                                                        <i className="bi bi-x-lg"></i>
                                                    </Button>
                                                    </div>
                                                )}
                                            {/* Botón de enviar */}
                                            <Button variant="primary" onClick={()=>changeStatus(newStatus, logEntry2, attachedFile2)}>
                                            {isSubmitting ? 'Cambiando...' : 'Cambiar estado ➤'}
                                            </Button>
                                        </div>
                                    </div>
              
                 }
 
 
        </Modal_proyectos>

        <Modal_proyectos
            isOpen={issueInventoryModalOpen}
            onClose={closeIssueInventoryModal}
            title={`Nuevo movimiento OUT (ticket #${issue_updating_id})`}
            overlayClassName="modal-overlay--elevated"
        >
            <div className="modal-inner">
                {issueInventoryError ? (
                    <Alert variant="danger" className="mb-3 py-2" dismissible onClose={() => setIssueInventoryError('')}>
                        {issueInventoryError}
                    </Alert>
                ) : null}
                <Form.Group className="mb-3">
                    <Form.Label>Producto <span className="text-danger">*</span></Form.Label>
                    <Select
                        classNamePrefix="react-select"
                        options={issueInventoryProductOptions}
                        value={issueInventoryProduct}
                        onChange={(opt) => {
                            setIssueInventoryProduct(opt);
                            setIssueInventoryProductTouched(true);
                        }}
                        onBlur={() => setIssueInventoryProductTouched(true)}
                        placeholder="Seleccionar producto…"
                        isClearable
                        isSearchable
                        noOptionsMessage={() => 'Sin productos en inventario del CAS'}
                        getOptionValue={(opt) => String(opt.value)}
                        getOptionLabel={(opt) => String(opt.label ?? '')}
                    />
                    {issueInventoryProductInvalid ? (
                        <Form.Control.Feedback type="invalid" className="d-block">
                            Seleccione un producto.
                        </Form.Control.Feedback>
                    ) : null}
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Cantidad <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                        type="number"
                        min={1}
                        step={1}
                        value={issueInventoryQty}
                        onChange={(e) => setIssueInventoryQty(e.target.value)}
                        onBlur={() => setIssueInventoryQtyTouched(true)}
                        isInvalid={issueInventoryQtyInvalid}
                        placeholder="Unidades"
                    />
                    {issueInventoryQtyInvalid ? (
                        <Form.Control.Feedback type="invalid">
                            Indique un entero mayor o igual a 1.
                        </Form.Control.Feedback>
                    ) : null}
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Referencia</Form.Label>
                    <Form.Control
                        type="text"
                        value={issueInventoryRef}
                        onChange={(e) => setIssueInventoryRef(e.target.value)}
                        placeholder="Opcional"
                    />
                </Form.Group>
                <Form.Group className="mb-0">
                    <Form.Label>Descripción</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        value={issueInventoryDescription}
                        onChange={(e) => setIssueInventoryDescription(e.target.value)}
                        placeholder="Opcional"
                    />
                </Form.Group>
            </div>
            <div className="modal-footer-fixed">
                <Button variant="outline-secondary" type="button" disabled={issueInventorySaving} onClick={closeIssueInventoryModal}>
                    Cancelar
                </Button>
                <Button variant="danger" type="button" disabled={issueInventorySaving} onClick={saveIssueInventoryOutMovement}>
                    {issueInventorySaving ? 'Guardando…' : 'Agregar OUT'}
                </Button>
            </div>
        </Modal_proyectos>
      
 
      <div className={`new-annotation-form p-3 border rounded shadow-sm ${CAS_name ? 'bg-info-subtle text-info-emphasis' : 'bg-light'}`}>

            <div className="row align-items-center mb-3">
                <div className="col-lg-1 col-md-12">
                        <button
                        type="button"
                        className="btn btn-light rounded-circle d-flex align-items-center justify-content-center"
                        onClick={onCloseAnnotation}
                        title="Atrás"
                        style={{ width: '40px', height: '40px' }}
                        >
                        {/* Aumentamos un poco el tamaño del ícono para que se vea mejor */}
                        <i className="bi bi-arrow-left fs-3"></i>
                    </button>
                </div>
                <div className="col-lg-5 col-md-12">
                    <h6 className="mb-0">#{issue_updating_id }</h6>
                    <h4 className="mb-0">{creationDate }</h4>
                    <h5 className="mb-0">{ " creada por: " + creator}</h5>
                </div>

                <div className="col-lg-2 col-md-12">
                    <div className="row align-items-center">
                    <label htmlFor="annotation-channel" className="col-form-label">
                    Medio de contacto:
                    </label>
                    <div >
                        <select
                        id="annotation-channel"
                        className="form-select py-2"
                        value={canal}
                        onChange={(e) => {
                            if (estado==1){
                                setcanal(e.target.value);
                                setchange2Save(true);
                            }
                        }}
                        >
                        <option value="WhatsApp">WhatsApp</option>
                        <option value="Telefonico">Telefónico</option>
                        <option value="Email">Email</option>
                        <option value="Presencial">Presencial</option>
                        <option value="Otro">Otro</option>
                        </select>
                    </div>
                    </div>
                </div>
                <div className="col-lg-2 col-sm-12" >
                    {
                         CAS_name && CAS_name.length > 0 ? (
                         <>
                        <label htmlFor="annotation-channel" className="col-form-label">
                         Remitido a cas: 
                         </label>
                         <div>
                         <Badge>{CAS_name}</Badge>
                         </div>
                         </>):
                        
                         <button type="button" className="btn btn-secondary w-100"  onClick={() => {
                                    setCasRemitMode('with_flow');
                                    setmodal_content("CAS_link");
                                    setModalOpen(true);
                                }} >
                    Remitir a CAS
                    </button>
                    }
                   
                </div>

                
            
                <div className="col-lg-2 col-sm-12" >
                    <select
                    id="annotation-status"
                    className="form-control"
                    value={estado}
                    onChange={(e) => handelStatusChange(e.target.value, e.target.options[e.target.selectedIndex].text)}
                    >
                    <option value="0">🟢 Cerrado</option>
                    <option value="1">🔴 Abierto</option>
                    <option value="2">🔵 Observación</option>
                    </select>
                </div>
                
                
            </div>

            <div className="row">
                {/* -- Campo Persona de contacto -- */}
                <div className="col-md-3">
                    <div className="row align-items-center">
                
                    <label htmlFor="contacto" className="col-form-label">
                    Persona de contacto:
                    </label>
            
                    <div >
                        <input
                        type="text"
                        id="contacto"
                        className="form-control"
                        value={persona_contacto}
                        onChange={(e) => {
                                if (estado==1){
                            setpersona_contacto(e.target.value);
                            setchange2Save(true);
                                }
                        }}
                        />
                    </div>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="row align-items-center">
                    
                    <label htmlFor="contacto" className="col-form-label">
                    Email:
                    </label>
                
                    <div >
                        <input
                        type="text"
                        id="contacto"
                        className="form-control"
                        value={email_contacto}
                        onChange={(e) => {
                                if (estado==1){
                            setEmail_contacto(e.target.value);
                            setchange2Save(true);
                                }
                        }}
                        />
                    </div>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="row align-items-center">
                    
                    <label htmlFor="contacto" className="col-form-label">
                    Telefono:
                    </label>
                
                    <div >
                        <input
                        type="text"
                        id="contacto"
                        className="form-control"
                        value={telefono_contacto}
                        onChange={(e) => {
                                if (estado==1){
                            setTelefono_contacto(e.target.value);
                            setchange2Save(true);
                                }
                        }}
                        />
                    </div>
                    </div>
                </div>

                {/* -- Campo Canal -- */}
                <div className="col-md-3">
                   <div className="row align-items-center">
                    
                    <label htmlFor="contacto" className="col-form-label">
                        Dirección:
                    </label>
                
                    <div >
                        <input
                        type="text"
                        id="contacto"
                        className="form-control"
                        value={direccion_contacto}
                        onChange={(e) => {
                                if (estado==1){
                            setDireccion_conctacto(e.target.value);
                            setchange2Save(true);
                                }
                        }}
                        />
                    </div>
                    </div>
                </div>
            </div>
            <div className="row my-4 col-12"> 
                
                {/* Columna 1: Tipología */}
                <div className="col-3">
                    <div className="fw-normal d-flex align-items-center gap-2">
                        <h6 className="mb-0 fw-normal">Tipologia:</h6>
                        <div className="d-flex flex-wrap gap-2 justify-content-lg-end">
                            {typos.map((s) => {
                                const dynamicColor = getColorForId(parseInt(s.type_id));
                                return (
                                    <span
                                        key={s.link_id}
                                        className="badge pill chip d-inline-flex align-items-center gap-2 px-3 py-2 fs-8"
                                        style={{ backgroundColor: dynamicColor, cursor: 'pointer' }}>

                                        {s.name_issue_type && s.name_issue_type.length > 25
                                            ? s.name_issue_type.slice(0, 25) + '...'
                                            : s.name_issue_type}

                                        {estado != 0 ? (
                                            <button
                                                aria-label={`Remove ${s.name_issue_type}`}
                                                className="btn-close btn-close-white btn-close-sm ms-1"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    onRemoveTypo(s.link_id);
                                                }}
                                            />
                                        ) : null}
                                    </span>
                                );
                            })}
                        </div>

                        {estado != 0 ? (
                            <Button
                                variant="outline-dark"
                                size="sm"
                                className="square-btn"
                                onClick={() => {
                                    setmodal_content("Type_link");
                                    setModalOpen(true);
                                }}
                            >
                                +
                            </Button>
                        ) : null}
                    </div>
                </div>
                 <div className="col-5 ">
                    <div className="fw-normal d-flex align-items-center gap-2">
                        <h6 className="mb-0 fw-normal">Vinculado a:</h6>
                        <div className="d-flex flex-wrap gap-2 justify-content-lg-end">
                           {Bugs.map((s) => {
                            const dynamicColor = getColorForId(parseInt(s.bug_id));
                            return (
                                <span
                                key={s.link_id}
                                className="badge pill chip d-inline-flex align-items-center gap-2 px-3 py-2 fs-8"
                                style={{ backgroundColor: dynamicColor, cursor: 'pointer' }}
                                onClick={(e) => {
                                    // Detiene la propagación para evitar que un evento padre se active, si lo hubiera
                                    e.stopPropagation(); 
                                    // Verifica si la URL de Trello existe antes de intentar abrirla
                                    if (s.trello_url) {
                                    window.open(s.trello_url, '_blank', 'noopener noreferrer');
                                    }
                                }}
                                >
                                {s.title && s.title.length > 18
                                    ? s.title.slice(0, 18) + '...'
                                    : s.title}
                                {estado != 0 ? (
                                    <button
                                    aria-label={`Remove ${s.title}`}
                                    className="btn-close btn-close-white btn-close-sm ms-1"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onRemoveBug(s.link_id);
                                    }}
                                    />
                                ) : null}
                                </span>
                            );
                            })}
                        </div>

                        {estado != 0 ? (
                            <Button
                                variant="outline-dark"
                                size="sm"
                                className="square-btn"
                                onClick={() => {
                                    setmodal_content("Bugs_link");
                                    setModalOpen(true);
                                }}
                            >
                                +
                            </Button>
                        ) : null}
                    </div>
                </div>

                {/* Columna 2: Observadores */}
                <div className="col-4 ">
                    <div className="fw-normal d-flex align-items-center gap-2">
                        <h6 className="mb-0 fw-normal">Observadores:</h6>
                        <div className="d-flex flex-wrap gap-2 justify-content-lg-end">
                            {observers.map((s) => {
                                const dynamicColor = getColorForId(parseInt(s.team_usr_id));
                                return (
                                    <span
                                        key={s.link_id}
                                        className="badge pill chip d-inline-flex align-items-center gap-2 px-3 py-2 fs-8"
                                        style={{ backgroundColor: dynamicColor, cursor: 'pointer' }}>

                                        {s.name && s.name.length > 25
                                            ? s.name.slice(0, 25) + '...'
                                            : s.name}

                                        {estado != 0 ? (
                                            <button
                                                aria-label={`Remove ${s.name}`}
                                                className="btn-close btn-close-white btn-close-sm ms-1"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    onRemoveObserver(s.link_id);
                                                }}
                                            />
                                        ) : null}
                                    </span>
                                );
                            })}
                        </div>

                        {estado != 0 ? (
                            <Button
                                variant="outline-dark"
                                size="sm"
                                className="square-btn"
                                onClick={() => {
                                    setmodal_content("Team_link");
                                    setModalOpen(true);
                                }}
                            >
                                +
                            </Button>
                        ) : null}
                    </div>
                </div>
                
            </div>
            
             {CAS_name && CAS_name.length && Number(CASstatus) > 0 &&
            <div className="col-12">
                <StatusBar currentStep={parseInt(CASstatus)} onStepClick={(step, title)=>changeCASStatus(step, title)} />
            </div>
        }

            <div className="col-12 mt-2">
                <div className="border rounded p-3 bg-white">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                        <h6 className="mb-0">Inventario CAS (ticket #{issue_updating_id})</h6>
                        {estado != 0 ? (
                            <Button
                                variant="danger"
                                size="sm"
                                onClick={openIssueInventoryModal}
                            >
                                <i className="bi bi-plus-lg me-1"></i>
                                Agregar movimiento OUT
                            </Button>
                        ) : null}
                    </div>
                    {issueInventoryError ? (
                        <Alert variant="danger" className="py-2 mb-2">
                            {issueInventoryError}
                        </Alert>
                    ) : null}
                    <Table responsive hover className="mb-0 align-middle">
                        <thead>
                            <tr>
                                <th>Fecha</th>
                                <th>Producto</th>
                                <th className="text-end">Cantidad</th>
                                <th>Usuario</th>
                                <th>Ref</th>
                                <th>Descripción</th>
                                <th className="text-end">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {issueInventoryLoading ? (
                                <tr>
                                    <td colSpan={7} className="text-center text-muted py-3">
                                        Cargando movimientos...
                                    </td>
                                </tr>
                            ) : issueInventoryRows.length === 0 ? (
                                <tr>
                                    <td colSpan={7} className="text-center text-muted py-3">
                                        No hay movimientos de inventario asociados a este ticket.
                                    </td>
                                </tr>
                            ) : (
                                issueInventoryRows.map((m) => (
                                    <tr key={`issue-inv-${m.id}`}>
                                        <td>{formatInventoryDate(m.date_time)}</td>
                                        <td>{m.root_material_name || `#${m.root_material_id}`}</td>
                                        <td className={`text-end ${m.qty < 0 ? 'text-danger fw-semibold' : ''}`}>{m.qty}</td>
                                        <td>{m.usr_name || `#${m.usr_id}`}</td>
                                        <td>{m.ref || '—'}</td>
                                        <td>{m.description || '—'}</td>
                                        <td className="text-end">
                                            {estado != 0 ? (
                                                <Button
                                                    variant="outline-danger"
                                                    size="sm"
                                                    onClick={() => removeIssueInventoryMovement(m.id)}
                                                >
                                                    Eliminar
                                                </Button>
                                            ) : '—'}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>
            </div>
     
            {change2Save?(
              <div className="mt-3 d-flex justify-content-end gap-2"> 
                <button type="button" className="btn btn-success" onClick={updateAnnotation} >
                  Guardar Anotación
                </button>
              </div>
            ):null
            }         
        </div>
   

        <Row className="mt-4 text-start">
            <Col>
            <Form.Label>Seguimiento:</Form.Label>

 
            <div style={{ position: 'relative' }}>

                {/* 2. Capa de carga que se muestra condicionalmente */}
                {isSubmitting && (
                    <div className="loading-overlay">
                        {/* Puedes usar un ícono de Bootstrap, FontAwesome o un spinner */}
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Enviando...</span>
                        </div>
                    </div>
                )}

                {/* Tu contenido actual del formulario */}
                <div className={`mb-2 ${isSubmitting ? 'content-blocked' : ''}`}>
                <ReactQuill
                theme="snow"
                value={logEntry}
                onChange={setLogEntry}
                modules={modules}
                placeholder="El usuario verá la anotación que agregues aquí..."
                />
            </div>

            {/* Ponemos los botones de acción juntos debajo del editor */}
            <div className="d-flex justify-content-end align-items-center gap-2 mb-2">
                
                {/* Botón para adjuntar archivo (ahora separado) */}
                 <Button 
                        variant="outline-secondary" 
                        onClick={() => document.getElementById('file-upload-input').click()} 
                        title="Adjuntar evidencia"
                    >
                        <i className="bi bi-paperclip"></i>
                    </Button>
                    
                    {/* Input de archivo, permanece oculto */}
                    <Form.Control
                        id="file-upload-input"
                        type="file"
                        className="d-none"
                        onChange={(e) => handleFileChange(e)}
                    />
                    
                    {/* Esta sección solo aparece si hay un archivo adjunto */}
                    {attachedFile && (
                        <div className="d-flex align-items-center mt-2 p-2 border rounded">
                        <span className="me-auto">
                            <strong>Adjunto:</strong> {attachedFile.name}
                        </span>
                        {/* Botón para eliminar el archivo adjunto */}
                        <Button 
                            variant="outline-danger" 
                            size="sm" 
                            onClick={() => setattachedFile(null)} 
                            title="Quitar archivo"
                        >
                            <i className="bi bi-x-lg"></i>
                        </Button>
                        </div>
                    )}
                {/* Botón de enviar */}
                <Button variant="primary" onClick={()=>sendLog(logEntry, attachedFile)}>
                {isSubmitting ? 'Enviando...' : 'Enviar ➤'}
                </Button>
            </div>
        </div>
            {/* --- FIN DEL CÓDIGO MODIFICADO --- */}

            {/* 4. Muestra el contenido formateado de forma SEGURA */}
            <div className="log-box text-left">
                {log.length === 0 ? (
                <p className="text-muted fst-italic">No hay entradas en el registro aún.</p>
                ) : (
                log.map((l) => (
                  <div key={l.id} className={`p-3 rounded mb-3 shadow-sm border ${parseInt(l.type) != 0 ? 'bg-secondary text-white' : 'bg-light'}`}>
                    {/* ... (Tu código para mostrar la insignia de usuario, fecha, etc.) ... */}
                    <div className="d-flex flex-column flex-sm-row align-items-sm-baseline mb-2 gap-3">
                        <Badge  
                                             bg="warning"
                                             pill
                                             className="chip d-inline-flex align-items-center px-3 py-2 fs-8"
                                           >
                                             {l.user_by}
                                           </Badge>
                       
                                           <span className="text-muted small">
                                             {new Date(l.issue_date).toLocaleString()}
                                           </span>

                      {l.url_attached!==""?(
                      <a href={l.url_attached} target='_blank'>
                        < i className="bi bi-paperclip"></i> 
                      </a> 
                      ):null
                      }
                    </div>
                    
                    {/* Para renderizar el HTML de forma segura, usamos DOMPurify */}
                    <div
                        className=" lh-sm text-start"
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(l.description.replace(/\r?\n/g, '<br />')) }}
                    />
                      
                    </div>
                ))
                )}
            </div>
            </Col>
        </Row>
        
        </>
    );
};

export default Ticket_panel;